import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  setTextLinksToDisplayExternalOpenMsg
} from 'zoomforth_codesbane_viewer/lib/page_content_utils.js';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

const GridTileCaption_ViewerVersion1 = ({ tellRef, horizontalAlign, captionHtml, ...props })=> {
  const style = {};

  if (horizontalAlign) {
    style['textAlign'] = horizontalAlign;
  }

  const {
    contentUuid,
    captionData,
    innerTileStyle,
    isTileOnRightishSide,
    shouldShowCaptionEditor,
    mostCommonThemeFontColors,
    mostCommonThemeBackgroundColors,
    onCaptionChange,
    onPaste,
    ...restProps
  } = props;

  if (!captionData) {
    return null;
  }

  const {
    orientation: captionOrientation,
    heightType: captionHeightType,
    heightValue: captionHeightValue
  } = captionData;

  const { backgroundColor, color } = innerTileStyle;

  const captionComputedStyles = {
    ...style,
    backgroundColor,
    color,
    top: (
      captionOrientation === 'underneath' ?
        captionHeightType === 'none' ?
          null
        : captionHeightType === 'small' ?
          '60%'
        : captionHeightType === 'medium' ?
          '50%'
        : captionHeightType === 'large' ?
          '40%'
        : captionHeightType === 'custom' ?
          `${Math.abs(captionHeightValue - 100)}%`
        :
          null
      :
        null
    )
  };
  
  return (
    <div 
      ref={tellRef}
      style={captionComputedStyles}
      className="tile-caption" 
      dangerouslySetInnerHTML={{__html: captionHtml}}
      { ...restProps }
    />
  );
};

class GridTileCaption_ViewerVersion2 extends Component {

  constructor(props) {
    super(props);
    this.wrapperNodeRef = null;
  }

  componentDidMount() {
    this.doPostRender();
  }
  
  componentDidUpdate() {
    this.doPostRender();
  }

  doPostRender() {
    setTextLinksToDisplayExternalOpenMsg(this.wrapperNodeRef, 'a');
  }

  render(){
    return (
      <GridTileCaption_ViewerVersion1
        { ...this.props }
        tellRef={(ref)=> {
          this.wrapperNodeRef = ref;
        }}
      />
    );
  }

}

const GridTileCaption = (props)=> (
  <SiteViewerVersionComponentSelector>
    <GridTileCaption_ViewerVersion1 forSiteViewerVersion={1} { ...props } />
    <GridTileCaption_ViewerVersion2 forSiteViewerVersion={2} { ...props } />
  </SiteViewerVersionComponentSelector>
);

GridTileCaption.propTypes = {
  captionHtml: PropTypes.string.isRequired,
  horizontalAlign: PropTypes.string
};

export default GridTileCaption;
